import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFromOtherCollectionPoint = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "#FEF6EA"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_24649_308875)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M11.9996 5C8.88294 5 6.49961 7.23438 6.49961 10.1562C6.49961 13.5938 11.9996 18.75 11.9996 18.75C11.9996 18.75 17.4996 13.5938 17.4996 10.1562C17.4996 7.23438 15.1163 5 11.9996 5Z",
				fill: "white",
				stroke: "#B47F23",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M11.9996 12C12.828 12 13.4996 11.3284 13.4996 10.5C13.4996 9.67157 12.828 9 11.9996 9C11.1712 9 10.4996 9.67157 10.4996 10.5C10.4996 11.3284 11.1712 12 11.9996 12Z",
				fill: "#B47F23"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_24649_308875",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledFromOtherCollectionPoint);
const Memo = memo(ForwardRef);
export default Memo;
